// extracted by mini-css-extract-plugin
export default {"onlyDark":"CV_onlyDark__gK49q","onlyLight":"CV_onlyLight__34F-I","cv":"CV_cv__EENvn","cv-content":"CV_cv-content__H6Yof"};